import { useTranslation } from "react-i18next";

import { ApiError } from "@/lib/api";

export function LoadingState({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div className="card p-8 text-center text-text-muted font-mono text-sm">
      {label ?? t("common.loading")}
    </div>
  );
}

export function EmptyState({
  title,
  hint,
}: {
  title: string;
  hint?: string;
}) {
  return (
    <div className="card p-10 text-center">
      <p className="text-text-primary text-lg">{title}</p>
      {hint && <p className="text-text-muted text-sm mt-2">{hint}</p>}
    </div>
  );
}

export function ErrorState({ error }: { error: unknown }) {
  const isApi = error instanceof ApiError;
  const code = isApi ? error.code : "ERROR";
  const message =
    error instanceof Error ? error.message : "Unknown error occurred";
  return (
    <div className="card p-6 border-danger/40">
      <p className="font-mono text-xs uppercase tracking-widest text-danger">
        {code}
      </p>
      <p className="text-text-primary mt-1">{message}</p>
      {isApi && error.details && (
        <pre className="mt-3 p-3 bg-surface-alt rounded text-xs text-text-secondary overflow-x-auto">
          {JSON.stringify(error.details, null, 2)}
        </pre>
      )}
    </div>
  );
}
